import React, { useEffect, useState } from "react";
import { observer } from "mobx-react";
import {
  Button,
  Divider,
  Modal,
  Stack,
  TextInput,
  Text,
  Menu,
  Alert,
  ActionIcon,
  CopyButton,
} from "@mantine/core";

import { Cubby } from "../../stores/Cubby";
import { MODALS } from "../../helpers/constants";
import {
  IconAt,
  IconFileInvoice,
  IconInfoCircle,
  IconKey,
  IconWriting,
  IconCheck,
  IconCopy,
} from "@tabler/icons-react";
import { TextWithInfo } from "./textWithInfo";
import { TextWithInfoAndIcon } from "../dataDisplay/textWithInfoAndIcon";
import { ARTICLES } from "../../docs/docsIndex";

const SignMessage = observer(({ cubby }: { cubby: Cubby }) => {
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const handleButtonClick = () => {
    setIsButtonDisabled(true);
    cubby.cubbyLife("sign_message", {
      stagedUserInputForNodeSignature: cubby.stagedUserInputForNodeSignature,
    });
    setTimeout(() => {
      setIsButtonDisabled(false);
    }, 3000);
  };

  const reset = () => {
    cubby.setStagedUserInputForNodeSignature("");
    cubby.setMessageThatWasSignedByNodeText("");
    cubby.setModal(null);
  };

  return (
    <>
      <Modal
        opened={cubby.currentModal == MODALS.SIGN_MESSAGE}
        onClose={() => reset()}
        title={
          <TextWithInfoAndIcon
            text="Sign Message With Node"
            articleSlug={ARTICLES.SIGN_MESSAGE.slug}
            icon={<IconWriting size={24} />}
            cubby={cubby}
            textSize="lg"
          />
        }
      >
        <Stack>
          <TextInput
            placeholder="Enter message to sign"
            label="Message"
            required
            value={
              cubby.stagedUserInputForNodeSignature
                ? cubby.stagedUserInputForNodeSignature
                : ""
            }
            onChange={(e) =>
              cubby.setStagedUserInputForNodeSignature(e.currentTarget.value)
            }
          />
          <Button
            leftSection={<IconWriting />}
            size="sm"
            variant="default"
            aria-label="sign message"
            onClick={handleButtonClick}
            disabled={isButtonDisabled}
          >
            Sign Message
          </Button>
          {cubby.messageThatWasSignedByNodeText && (
            <Stack>
              <Alert
                variant="light"
                color="blue"
                title="Signed Message"
                icon={<IconInfoCircle />}
              >
                <Text
                  size="xs"
                  style={{ wordBreak: "break-all", maxWidth: "80%" }}
                >
                  {cubby.messageThatWasSignedByNodeText}
                </Text>
                <CopyButton value={cubby.messageThatWasSignedByNodeText}>
                  {({ copied, copy }) => (
                    <Button
                      variant={copied ? "filled" : "default"}
                      color={copied ? "teal" : "blue"}
                      onClick={copy}
                      aria-label="copy signed message"
                    >
                      Copy {copied ? <IconCheck /> : <IconCopy />}
                    </Button>
                  )}
                </CopyButton>
              </Alert>
              <Text>
                This signature can be verified by anyone with your public key.
              </Text>
            </Stack>
          )}
        </Stack>
      </Modal>
    </>
  );
});

export default SignMessage;
